"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.organizationRef = exports.Organization = void 0;
var lodash_1 = require("lodash");
var mobx_keystone_1 = require("mobx-keystone");
var moment_1 = __importDefault(require("moment"));
var config_1 = __importDefault(require("../config"));
var load_1 = require("../constants/load");
var Organization = /** @class */ (function (_super) {
    __extends(Organization, _super);
    function Organization() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getRefId = function () { return "".concat(_this.id); };
        _this.getTemplate = function (status) {
            switch (status) {
                case load_1.LOAD_STATUS.PENDING_ACCEPTANCE:
                case load_1.LOAD_STATUS.ACTIVE:
                    return _this.templateDriverAssigned;
                case load_1.LOAD_STATUS.ASSIGNED:
                    return _this.templateDriverAccepted;
                case load_1.LOAD_STATUS.DECLINED:
                    return _this.templateDriverDeclined;
                case load_1.LOAD_STATUS.PICKUP_GOING:
                    return _this.templatePickupGo;
                case load_1.LOAD_STATUS.PICKUP_ARRIVED:
                case load_1.LOAD_STATUS.PICKUP_CHECKIN:
                    return _this.templatePickupArrived;
                case load_1.LOAD_STATUS.PICKUP_DEPARTED:
                case load_1.LOAD_STATUS.DROPOFF_GOING:
                    return _this.templateDropoffGoing;
                case load_1.LOAD_STATUS.DROPOFF_ARRIVED:
                case load_1.LOAD_STATUS.DROPOFF_CHECKIN:
                    return _this.templateDropoffArrived;
                case load_1.LOAD_STATUS.COMPLETED:
                    return _this.templateDropoffCompleted;
                default:
                    console.warn('[DEBUG] no template exists for status', status);
                    return '';
            }
        };
        _this.getSharedMessage = function (load) {
            var isPickup = load.isPickupStatus;
            var template = _this.getTemplate(load.status);
            var source = {
                loadId: "".concat(load.id),
                loadBillOfLadingNumber: load.billOfLadingNumber || '',
                loadQuantity: "".concat(load.loadQuantity),
                loadQuantityUnit: load.loadQuantityUnit && load.loadQuantityUnit.isValid
                    ? load.loadQuantityUnit.current.name
                    : '',
                loadDescription: load.loadDescription,
                loadUrl: "".concat(config_1.default.urls.web, "l/").concat(load.orderLegLinkId),
                // TODO: get contact based on schedule and eta.
                pickupContactName: 'someone',
                dropoffContactName: 'someone',
            };
            if (load.driver && load.driver.isValid) {
                var driver = load.driver.current;
                source['driverName'] = driver.name;
            }
            if (load.pickupLocation && load.pickupLocation.isValid) {
                var location_1 = load.pickupLocation.current;
                source['pickupLocation'] = location_1.name;
                if (isPickup) {
                    source['destinationLocation'] = location_1.name;
                }
            }
            if (load.dropoffLocation && load.dropoffLocation.isValid) {
                var location_2 = load.dropoffLocation.current;
                source['dropoffLocation'] = location_2.name;
                if (!isPickup) {
                    source['destinationLocation'] = location_2.name;
                }
            }
            if (load.etas) {
                if (load.etas.pickupEta) {
                    source['pickupDuration'] = (0, moment_1.default)(load.etas.pickupEta.eta).fromNow();
                    if (isPickup) {
                        source['etaTime'] = (0, moment_1.default)(load.etas.pickupEta.eta).format('HH:mm:ss');
                    }
                }
                if (load.etas.dropoffEta) {
                    source['dropoffDuration'] = (0, moment_1.default)(load.etas.dropoffEta.eta).fromNow();
                    if (!isPickup) {
                        source['etaTime'] = (0, moment_1.default)(load.etas.dropoffEta.eta).format('HH:mm:ss');
                    }
                }
            }
            return template.replace(/{(.*?)}/g, function (x, key) {
                var value = source[(0, lodash_1.camelCase)(key)];
                if (value && value.length > 0) {
                    return value;
                }
                else {
                    console.warn("[DEBUG] key doesn't exist in source", key, source);
                    return '';
                }
            });
        };
        return _this;
    }
    Organization = __decorate([
        (0, mobx_keystone_1.model)('doc-mate/Organization')
    ], Organization);
    return Organization;
}((0, mobx_keystone_1.Model)({
    id: (0, mobx_keystone_1.prop)(),
    name: (0, mobx_keystone_1.prop)(),
    templateDriverAssigned: (0, mobx_keystone_1.prop)(),
    templateDriverAccepted: (0, mobx_keystone_1.prop)(),
    templateDriverDeclined: (0, mobx_keystone_1.prop)(),
    templatePickupGo: (0, mobx_keystone_1.prop)(),
    templatePickupNearby: (0, mobx_keystone_1.prop)(),
    templatePickupArrived: (0, mobx_keystone_1.prop)(),
    templateDropoffGoing: (0, mobx_keystone_1.prop)(),
    templateDropoffNearby: (0, mobx_keystone_1.prop)(),
    templateDropoffArrived: (0, mobx_keystone_1.prop)(),
    templateDropoffCompleted: (0, mobx_keystone_1.prop)(),
    templateDelayTraffic: (0, mobx_keystone_1.prop)(),
    templateDelayBreakdown: (0, mobx_keystone_1.prop)(),
    templateLoadProblem: (0, mobx_keystone_1.prop)(),
})));
exports.Organization = Organization;
exports.organizationRef = (0, mobx_keystone_1.rootRef)('doc-mate/OrganizationRef', {
    getId: function (target) {
        if (target instanceof Organization) {
            return "".concat(target.id);
        }
    },
});
